/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Typography } from "@mui/material";
import Container from "@/src/components/Container/Container";
import React from "react";
import Section from "@/src/components/Section/Section";
import { OpacityFillingText } from "@/src/animations/OpacityFillingText/OpacityFillingText";

export default function ValueProposition() {
  return (
    <Section component={"div"}>
      <Container variant={"md"} showVerticalPadding={false} sx={{ textAlign: "center" }}>
        <OpacityFillingText
          text={
            "Wir stehen Ihnen mit jahrelanger anwaltlicher Expertise und modernster Technologie zur Seite. Sie behalten jederzeit den Überblick und werden " +
            "professionell und persönlich von uns begleitet."
          }
        />
      </Container>
    </Section>
  );
}
